import { CloseOutlined, HelpOutline } from '@mui/icons-material'
import { Button, Card, CardContent, Checkbox, IconButton, Input, Link, Modal, Stack, Textarea, Tooltip, Typography } from '@mui/joy'
import React, { ReactNode, useState } from 'react'
import { headCardModalAlertMobile as head } from './utils/headCardModalAlertMobile'
import useCardModalAlertMobile from './utils/useCardModalAlertMobile'

type Props = {
  slot?: { button?: ReactNode }
}

const CardModalAlertMobile = ({ slot }: Props) => {

  const {
    open,
    dismissModal,
    dontShowAgain,
    setDontShowAgain,
  } = useCardModalAlertMobile({})

  return (
    <>
      <Modal
        open={open}
        onClose={dismissModal}
        sx={{ display: 'grid' }}
      >
        <Stack sx={{ justifySelf: 'center', }}>
          <Card sx={{ gap: 2, maxWidth: 400, my: 'auto', px: { xs: 2, md: 4 }, py: 3, mx: 1, maxHeight: '90vh', overflow: 'auto' }}>
            <Stack>
              <img src={require('assets/illustration-access-mobile-denied.svg').default} style={{ height: 'min(90vh, 200px)' }} />
            </Stack>
            <Stack gap={2}>
              <Typography textAlign={'center'} level="h4">{head.title}</Typography>
              <Typography textAlign={'center'} level="body-sm">{head.message}</Typography>
            </Stack>
            <CardContent sx={{ gap: 2, flexDirection: 'column' }}>
              <Link href={head.href} onClick={dismissModal} sx={{ width: 1 }}>
                <Button sx={{ height: 1 }} fullWidth variant='solid'>Read Guidelines</Button>
              </Link>
              <Link onClick={dismissModal} sx={{ width: 1 }}>
                <Button sx={{ height: 1 }} fullWidth variant='outlined'>Got it, Continue</Button>
              </Link>
              <Stack direction="row" alignItems="center" gap={1} sx={{ justifyContent: 'center' }}>
                <Checkbox sx={{'.MuiCheckbox-label':{fontFamily: 'body', color: '#8f8f8f', fontSize: '0.8rem'}}} label="Don't show again" checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} />
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Modal>
    </>
  )
}

export default CardModalAlertMobile